import React, { useEffect, useRef, useState } from 'react';
import SNFHeader from './header';
import { Switch, Route, useHistory } from 'react-router-dom';
import { useSidePanelContent } from './sidePanel/hooks';
import { Props as ITabPanelProps } from 'components/tab/headless/tabPanel';
import { Drop, Result, Analytics, Search, Canvas } from './index';
import { IStyle } from 'Styles';
import { withRouter } from 'react-router';
import { MatchParams } from 'constants/';
import {
  useCurrentSelectedWellDropDetails,
  useFetchDrawingPreferences,
  useFetchSearchDetails,
  useFetchSearchFilters,
  useFetchSearchTargetCharts,
  useFetchSearchTargetFieldsMap,
  useFetchSearchTargets,
  useIsFetchingSearchDetails,
  useSearchDetails,
} from 'redux/hooks/searchnFilter';
import LoadingDiv from 'components/generic/loadingDiv';
import BottomMenu from './bottomMenu/bottomMenu';
import { SearchAndFilterReportsDialogue } from 'components/reports/SearchAndFilterReportsDialogue';
import { useSnfKeyboardHandler } from './hooks';
import { getSnfWellKey } from './utils';
import { useFetchsearchGroupDetails } from 'redux/hooks/common';
import { useModalHandlers } from 'components/modal';
import { showPopupBlockedModal } from 'components/reports/utils';
import { useFileNotFoundModal } from 'CustomHooks/useFileNotFoundModal';
import { BooleanPropertyDTO } from 'business/models/Models';
import { PropertyConstants } from 'enums/PropertyConstants';
import { useSystemProperty } from 'CustomHooks/useSystemProperty';
interface RouteParams {
  id?: number;
}
type Props = MatchParams<RouteParams>;

export const bottomMenuAllowedRoutes = ['drop', 'compare', 'canvas'];
const dropRoutes = ['drop', 'compare'];

let zoomInvokerDelegate;

function setZoomInvocker(functionDelegate) {
  zoomInvokerDelegate = functionDelegate;
}

const SNFContainer = (props: Props) => {
  const { match } = props;
  const { id } = match.params;
  const history = useHistory();
  const [tabSelectors, tabContent] = useSidePanelContent();
  const fetchSearchDetails = useFetchSearchDetails();
  const searchDetails = useSearchDetails();
  const fetchSearchFilters = useFetchSearchFilters();
  const isfetchingDetails = useIsFetchingSearchDetails();
  const fetchDrawingPreferences = useFetchDrawingPreferences();
  const enableCanvasPref = useSystemProperty(
    PropertyConstants.SeachFilterEnableCanvas,
    false,
  );
  const isCanvasEnabled = (enableCanvasPref as BooleanPropertyDTO)?.value !== false;
  const isCanvasRoute = bottomMenuAllowedRoutes.some((substring) =>
    window.location.pathname.includes(substring),
  );
  const isDropMode = dropRoutes.some((route) => window.location.pathname.includes(route));
  const [reRenderKeyOnDiscard, setReRenderKeyOnDiscard] = useState(1);
  const [reportType, setReportType] = useState<string>('');
  const [showReportDialogue, setShowReportDialogue] = useState<boolean>(false);
  useSnfKeyboardHandler(zoomInvocker);
  const wellRefs = useRef<{ [key: string]: any }>({});
  const selectedWell = useCurrentSelectedWellDropDetails();
  const fetchSearchTargets = useFetchSearchTargets();
  const fetchSearchTargetFieldsMap = useFetchSearchTargetFieldsMap();
  const FetchScoreGroupDetails = useFetchsearchGroupDetails();
  const fetchSearchTargetCharts = useFetchSearchTargetCharts();
  const chartInstance = useRef(null);
  const { showModal: showModalSimple, hideModal } = useModalHandlers();
  const showFileNotFoundModal = useFileNotFoundModal();
  const [popupBlockedModal, setPopupBlockedModal] = useState(false);

  useEffect(() => {
    fetchSearchDetails(id);
    fetchSearchFilters(id);
  }, [id]);

  useEffect(() => {
    fetchDrawingPreferences();
    FetchScoreGroupDetails();
    fetchSearchTargets();
    fetchSearchTargetFieldsMap();
    fetchSearchTargetCharts();
  }, []);

  useEffect(() => {
    if (reportType != '') {
      setShowReportDialogue(true);
    } else {
      setShowReportDialogue(false);
    }
  }, [reportType]);

  useEffect(() => {
    if (
      id &&
      enableCanvasPref &&
      (enableCanvasPref as BooleanPropertyDTO).value === false &&
      isCanvasRoute
    ) {
      history.replace(`/snf/${id}/result`);
    }
  }, [id, enableCanvasPref, isCanvasRoute, history]);

  if (isfetchingDetails) {
    return <LoadingDiv />;
  }

  if (searchDetails.errorCode == 404) {
    showFileNotFoundModal();
    return;
  }

  const sidePanelWidth =
    (tabContent as React.Component<ITabPanelProps>).props?.width ?? 30;

  function zoomInvocker(zoomIn) {
    if (
      isDropMode &&
      selectedWell?.regionID &&
      selectedWell?.cpID &&
      selectedWell?.imageBatchId
    ) {
      triggerZoom(getSnfWellKey(selectedWell), zoomIn);
    } else {
      if (zoomInvokerDelegate) {
        zoomInvokerDelegate(zoomIn);
      }
    }
  }

  const setWellRef = (wellKey: string, ref: any) => {
    if (ref) {
      wellRefs.current[wellKey] = ref;
    } else {
      delete wellRefs.current[wellKey];
    }
  };

  const triggerZoom = (wellKey: string, zoomIn) => {
    if (wellRefs.current[wellKey]) {
      wellRefs.current[wellKey].ZoomHandler(zoomIn);
    }
  };
  return (
    <>
      <SNFHeader
        tabSelectors={tabSelectors}
        setReRenderKeyOnDiscard={setReRenderKeyOnDiscard}
        setReportType={setReportType}
        chartInstance={chartInstance}
      />
      <div id="snfcontainer-content-container" className="flex w-full h-full">
        <div
          id="snfcontainer-routes-wrapper"
          className={`flex  w-[${100 - sidePanelWidth}%]`}
        >
          <Switch>
            <Route exact path="/snf/:id" component={Search} key={reRenderKeyOnDiscard} />
            <Route
              exact
              path="/snf/:id/result"
              render={(props) => (
                <div id={`snfcontainer-content-result`} className="h-[90vh] w-full">
                  <Result {...props} />
                </div>
              )}
            />
            <Route
              exact
              path="/snf/:id/canvas"
              render={(props) => <Canvas {...props} setZoomInvocker={setZoomInvocker} />}
            />
            <Route
              exact
              path="/snf/:id/analytics"
              render={(props) => <Analytics {...props} chartInstance={chartInstance} />}
            />
            <Route
              exact
              path="/snf/:id/:wellMode?"
              render={(props) => (
                <Drop
                  {...props}
                  setZoomInvocker={setZoomInvocker}
                  setWellRef={setWellRef}
                />
              )}
            />
          </Switch>
        </div>

        {tabContent && (
          //@ts-ignore
          <div id="snfcontainer-sidepanel" style={styles.sidePanelRoot(sidePanelWidth)}>
            {tabContent}
          </div>
        )}
      </div>
      {isCanvasRoute && isCanvasEnabled && <BottomMenu zoomInvocker={zoomInvocker} />}

      {showReportDialogue && (
        <SearchAndFilterReportsDialogue
          reportType={reportType}
          setReportType={setReportType}
          onPopupBlocked={() => {
            setPopupBlockedModal(true);
          }}
        />
      )}
      {popupBlockedModal &&
        showPopupBlockedModal(showModalSimple, setPopupBlockedModal, hideModal)}
    </>
  );
};

const styles: IStyle = {
  //@ts-ignore
  sidePanelRoot: (width: number) => ({
    borderLeft: '1px solid rgb(159 159 159)',
    backgroundColor: 'white',
    width: `${width}%`,
  }),
};

export default withRouter(SNFContainer);
